<template>
    <Card :title="$t('crmAnalyticsPage.controlPanelTitle')">
        <div class="card-body">
            <div class="row">
                <div class="col-lg-2">
                    <FormGroup :label="$t('crmAnalyticsPage.periodLabel')">
                        <AppSelect
                            @update:model-value="$emit('update:selectedTimePeriod', $event)"
                            :model-value="selectedTimePeriod?.value"
                            :selected-value="selectedTimePeriod?.label"
                            :options="timePeriodOptions"
                            option-key="value"
                            option-value="label"
                        />
                    </FormGroup>
                </div>
                <div class="col-lg-2">
                    <FormGroup :label="$t('crmAnalyticsPage.dateFromLabel')">
                        <DatePicker :model-value="dateFrom" @update:model-value="$emit('update:dateFrom', new Date($event))" />
                    </FormGroup>
                </div>
                <div class="col-lg-2">
                    <FormGroup :label="$t('crmAnalyticsPage.dateToLabel')">
                        <DatePicker :model-value="dateTo" @update:model-value="$emit('update:dateTo', new Date($event))" />
                    </FormGroup>
                </div>
                <div class="col-lg-2">
                    <FormGroup :label="$t('crmAnalyticsPage.statusLabel')">
                        <AppMultiselect
                            :model-value="selectedOrderStatusType"
                            :options="orderStatusTypeOptions"
                            option-key="value"
                            option-value="label"
                            @update:model-value="$emit('update:selectedOrderStatusType', $event)"
                        />
                    </FormGroup>
                </div>
                <div class="col-lg-2">
                    <FormGroup :label="$t('crmAnalyticsPage.sourceLabel')">
                        <MultiAutoComplete
                            :url="`/projects/${$route.params.projectUuid}/crm/sources`"
                            :model-value="selectedSources"
                            @update:model-value="$emit('update:selectedSources', $event)"
                        />
                    </FormGroup>
                </div>
                <div class="col-lg-2 d-flex align-items-center">
                    <AppButton color="indigo" style="width: 100%" @click="$emit('apply')">
                        {{ $t('buttons.update') }}
                    </AppButton>
                </div>
            </div>
        </div>
    </Card>
</template>
<script>
import Card from '../../../../../components/new/CardComponent.vue'
import AppButton from '../../../../../components/new/button/AppButton.vue';
import FormGroup from '../../../../../components/new/form/group/FormGroup.vue';
import AppSelect from '../../../../../components/new/form/select/AppSelect.vue';
import DatePicker from '../../../../../components/new/form/datePiker/DatePicker.vue';
import MultiAutoComplete from '../../../../../components/new/form/autocomplete/MultiAutoComplete.vue';
import AppMultiselect from '../../../../../components/new/form/autocomplete/AppMultiselect.vue'

import { TimePeriodEnum } from '../../../../enums/TimePeriodEnum';
import { OrderStatusTypeEnum } from '../../../../enums/OrderStatusTypeEnum';

export default {
    name: 'ControlPanel',
    components: {
        Card, AppButton, AppSelect, DatePicker, FormGroup, MultiAutoComplete, AppMultiselect
    },
    emits: ['apply', 'update:selectedTimePeriod', 'update:dateFrom', 'update:dateTo', 'update:selectedOrderStatusType', 'update:selectedSources'],
    props: {
        selectedTimePeriod: {
            type: Object,
            required: true,
        },
        dateFrom: {
            type: Date,
            required: true,
        },
        dateTo: {
            type: Date,
            required: true,
        },
        selectedOrderStatusType: {
            type: Array,
            default: () => []
        },
        selectedSources: {
            type: Array,
            default: () => []
        }
    },
    data() {
        return {
            timePeriodOptions: [
                { value: TimePeriodEnum.DAY, label: this.$t('timePeriods.day') },
                { value: TimePeriodEnum.WEEK, label: this.$t('timePeriods.week') },
                { value: TimePeriodEnum.MONTH, label: this.$t('timePeriods.month') },
                { value: TimePeriodEnum.YEAR, label: this.$t('timePeriods.year') },
            ],
            orderStatusTypeOptions: [
                { value: OrderStatusTypeEnum.ACTIVE, label: this.$t('orderStatus.types.active') },
                { value: OrderStatusTypeEnum.DONE, label: this.$t('orderStatus.types.done') },
                { value: OrderStatusTypeEnum.CANCELED, label: this.$t('orderStatus.types.canceled') },
            ]
        }
    },

}
</script>